import fromAnyToInteger from 'utils/converters/fromAnyToInteger';
import fromAnyToString from 'utils/converters/fromAnyToString';

const padZeroes = (length, string) => {
  const str = fromAnyToString(string);
  const len = fromAnyToInteger(length);

  return !len || len < 0 || len < str.length ? str : (Array(len + 1).join('0') + str).slice(-len);
};

// noinspection JSUnusedGlobalSymbols
export default padZeroes;
